import { ActivityLogSchema } from '@ametista-ai/api-schema';
import { ApiResponse } from '@ametista-ai/api-schema/http/types';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/stores/api/apiClient';
import { postActivityLogsKeys } from './keys';

const REFETCH_INTERVAL_MS = 5 * 60 * 1000;

export function usePostActivityLogs(postId: string, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: postActivityLogsKeys.list(postId),
    queryFn: () => {
      return apiClient.get<ApiResponse<ActivityLogSchema[]>>(
        `/v1/posts/${postId}/activity`,
        undefined
      );
    },
    enabled: (options?.enabled ?? true) && !!postId,
    refetchInterval: REFETCH_INTERVAL_MS,
  });
}
